export default __webpack_public_path__ + "static/standards-0d7851e053498d316add853c3d6c823e.jpg";